import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { Routes } from '@/routes/router';
import ClipLoader from 'react-spinners/ClipLoader';

interface PrivateRouteProps {
    children: React.ReactElement;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
    const { user, initializing } = useAuth();

    if (initializing) {
        return (
            <div className="flex items-center justify-center h-screen">
                <ClipLoader color="#4A90E2" size={50} />
            </div>
        );
    }

    return user ? (
        children
    ) : (
        <Navigate
            to={Routes.PORTAL_PUBLIC}
            replace
        />
    );
};

export default PrivateRoute;
